import { Typography } from '@mui/material'
import get from 'lodash/get'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { i18n } from '../../index'
import ToiletCheckQuestionPage from './ToiletCheckQuestionPage'
import css from './toiletCheckQuestionPage.css'
import { toiletCheckQuestionsQuery } from './toiletCheckQuestionQueries'
import type { ToiletCheckQuestion } from './toiletCheckQuestionTypes'

type QueryData = { toiletCheckQuestions: Array<ToiletCheckQuestion> }

const ChainToiletCheckQuestionPage = () => (
  <div>
    <div className={css.top}>
      <Typography variant='h6'>{i18n.t('admin.toiletCheckQuestions.pageTitle')}</Typography>
    </div>
    <Query<QueryData, {}> query={toiletCheckQuestionsQuery}>
      {({ loading, error, data }) => (
        <Loader
          {...{
            loading,
            error,
          }}
        >
          <ToiletCheckQuestionPage data={get(data, 'toiletCheckQuestions')} />
        </Loader>
      )}
    </Query>
  </div>
)

export default ChainToiletCheckQuestionPage
